import Splide from '@splidejs/splide';
import "./components/item/ItemImageCarousel";
import "./components/exitintent/exitintent_popup";
import "./components/qrpages/qrpages";
/*** FACETS ***/
var bskIndex = 0;
/* CLIENT CONFIG 
$(document).ready(function(){
    if($('.data-image-create').length>0){
        createImages('.data-image-create');
    }
})
function createImages(selektor){
    $(selektor).each((function(){
        tmpImgCreate(JSON.parse(decodeURIComponent($(this).data('imgconfig'))), this, 'seitlich', false)
    }))
}
function tmpImgCreate(img_params, element, typeCfg, isZoom){
    var images_array = [];    
    var images_src;
 
    $.each( img_params, function( key, val ){
        if(typeCfg=="seitlich"){
            images_src = getImageSrcTmp(propertiesWomen[key][val].config.seitlich);
        }
        if(typeCfg=="schreag"){
            images_src = getImageSrcTmp(propertiesWomen[key][val].config.schreag);
        }
        if(typeCfg=="hinten"){
            images_src = getImageSrcTmp(propertiesWomen[key][val].config.hinten);
        }
        if(typeCfg=="oben"){
            images_src = getImageSrcTmp(propertiesWomen[key][val].config.oben);
        }
        images_array.push({
            src: images_src,
            x: 0,
            y: 0
        });
    });
   mergeImages(images_array,{crossOrigin: true}).then(function(b64){
       if(isZoom){
           $(element).find('img').attr("src", b64);
           $(element).attr("href", b64);
           $(element).attr("data-image", b64);
       }else{
           $(element).attr("src", b64)
       }  
    });

}
function getImageSrcTmp(img_src){
    var strato_url = "";
    if($('[data-itemid="123538378"]').length>0){
        strato_url = "https://www.js-1886.de/originalimages/damen/";
    }else{
        strato_url = "https://www.js-1886.de/originalimages/herren/";
    }
    strato_url = "https://cdn02.plentymarkets.com/rvjqi2f349b6/frontend/Konfigurator/ConfigTmp/";
    return strato_url + img_src.substring(img_src.lastIndexOf('/') + 1);
}*/
$(document).on( "click", ".tg-cookie-bg", function() {
    $('.cookie-bar').removeClass('out');
});
$(document).on('click','.js-dropdown:not(.disabled) .js-dropdown-value', function() {
    $('.facet-dropdown.is-open').not($(this).closest('.facet-dropdown')).removeClass('is-open');
    $(this).parents('.facet-dropdown').toggleClass('is-open');
    if($(this).hasClass('facet-dropdown-value')){
        $('.facet-head-title').html($.trim($(this).text())).removeClass('pl-2');
        $('.btn-close-single-filter').show();
    }
});
$(document).on('click','.variation-dropdown-value', function() {
    $('.variation-dropdown.is-open').not($(this).closest('.variation-dropdown')).removeClass('is-open');
    $(this).parents('.variation-dropdown').toggleClass('is-open');
});
$(document).on('click','.variation-dropdown .v-s-box', function() {
    $(this).closest('.variation-dropdown').removeClass('is-open');
    $('.variation-dropdown-ch-value').html($(this).closest('.variation-dropdown').find('.variation-dropdown-content .v-s-box.active').html());
});

$(document).on('click','.btn-more-filter', function() {
    $('.facet-filter-container').toggleClass('show-all-facets');
    if($('.facet-filter-container').hasClass('show-all-facets')){
        $(this).find('.bt-txt').html($(this).data('txtlessfilter'));
    }else{
        $(this).find('.bt-txt').html($(this).data('txtmorefilter'));
    }
    
});
$(document).on('click','.ekomi-widget-container .rating-stars', function() {
    $('.nav-link[href="#ekomi_prc_tab"]').trigger('click')
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".single-description-wrap").offset().top
    }, 500);
});


$(document).on('click','.basket-open-coupon', function() {
    $(this).closest('.basket-coupon-container').toggleClass('is-open');
});
$(document).on('click','.link-item-shipping', function() {
    $("html, body").animate({scrollTop: $('.nav-link-shipping').offset().top - 80 }, 500,function(){
        $('.nav-link-shipping').trigger('click')
    });
});


$(document).on('click','.btn-open-wish-details', function() {
    $(this).closest('.col-wish-list').toggleClass('is-active');
});
$(document).on('click','.menu-unternehmen .nav-direction', function() {
    $(this).closest('li').toggleClass('is-active');
});



$(document).on('click','.btn-open-config-item', function() {
    var _this = this;
    var searchParams = {
        itemid: $('.config-singleitem').data('itemid'),
        imgvalues: $('.config-singleitem').attr('data-loadparams'),
        defaultids: $('.config-singleitem').attr('data-defaultids')
    };
    if($('.cfg-container').length<=0){
        $(this).addClass('is-load');
        $.get('/'+App.language+'/config-item/', searchParams, function( data ) {
            $('body').append(data);
            $('.cf-input-txt-left').val($('.config-singleitem').data('printtextleft'));
            $('.cf-input-txt-right').val($('.config-singleitem').data('printtextright'));
            $('.cfg-max-chars-left span').html($('.config-singleitem').data('printtextleft').length);
            $('.cfg-max-chars-right span').html($('.config-singleitem').data('printtextright').length);
            
            if($('.config-singleitem').data('printtextleft')!="" && $('.config-singleitem').data('printtextleft') != $('.config-singleitem').data('printtextright')){
                $('.cfg-item-wrap').addClass('bothTextShow');
                $('#bothText').prop( "checked", false );
            }
            if($('.config-singleitem').data('printcolorleft')!=""){
                $('.cfg-print-color-left[data-printcolor="'+$('.config-singleitem').data('printcolorleft')+'"]').addClass('active');
                $('.cfg-print-color-right[data-printcolor="'+$('.config-singleitem').data('printcolorright')+'"]').addClass('active');
            }else{
                $('.cfg-print-color-left').first().addClass('active');
                $('.cfg-print-color-right').first().addClass('active');
            }
            
            
            $('body').addClass('cf-config-show');
            initConfig();
            initSlider();
          
            $('.cfg-slide-item a').tooltip();
            /*$('.cfg-slide-item a').tooltip().on("mouseleave", function (e) {
                var _this = e.target;
                setTimeout(function () {
                    if (!$(".tooltip:hover").length) {
                        $(_this).tooltip("hide");
                    }
                }, 300);
            });*/
            /*$('body').on('click', function (e) {
                $('[data-toggle=popover]').each(function () {
                    // hide any open popovers when the anywhere else in the body is clicked
                    if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                        $(this).popover('hide');
                    }
                });
            });*/
            $(document).mouseup(function(e) 
            {
                var container = $(".tooltip");

                if (!container.is(e.target) && container.has(e.target).length === 0) 
                {
                    container.tooltip('hide');
                }
            });
            $(_this).removeClass('is-load');
        });
    }else{
        $('body').addClass('cf-config-show');
    }
});
$(document).on('click','.btn-open-filter', function() {
    $('body').toggleClass('filter-open');
});
$(document).on('click','.btn-close-single-filter', function() {
    $('.facet-head-title').html($('.facet-head-title').data('maintitle')).addClass('pl-2');
    $(this).closest('.facet-dropdown').removeClass('is-open');
    $('.btn-close-single-filter').hide();
});
$(document).on('click','.list-sorting label', function() {
    document.location = $(this).data('eg-href');
});
$(document).on('focusin','.mail-nl-ff', function() { 
    $(this).closest('form').find('.nl-privacy').show();
});

$(document).on('click','.btn-reset-single-filter', function() {  
    $(this).closest('.facet-dropdown-content').find('ul li input[type="text"]').val('').trigger('change');
    $(this).closest('.facet-dropdown-content').find('ul li input:checked').prop('checked', false).trigger('change');
    $(this).closest('.facet-dropdown-content').find('ul li').removeClass('facet-filter-checked');
    
});
$(document).on('change','.facet-price-input', function() {
    if($.trim($(this).val()).length>0){
        return setFacetTargetLink.call(this);
    }
});
$(document).on('change','.switch-nl-folder', function() {
    $('.newsletter-switch-folder').removeClass('active');
    $('.newsletter-switch-folder[data-mailfolder="'+$(this).children("option:selected").val()+'"]').addClass('active');
});
$(document).on('click','.btn-open-shoe-info', function() {
    if($('.shoe-size-info-item').length<=0){
        const lang = $(this).data('lang');
        $.ajax({
            url: `/${lang}/getShoeSizeInfos`,
            type: "get",
        }).done(function(data) {
            $('body').prepend(data.data);
            setTimeout(function(){ 
                $('body').addClass('shoe-size-info-open'); 
            }, 300);
        });
    }else{
        $('body').addClass('shoe-size-info-open');
    }
});
$(document).on('click','.shoe-size-info-layer, .close-shoe-size-info', function() {
    $('body').removeClass('shoe-size-info-open')
});


$(document).on('change','.facet-item-value-chk', function() {
    return setFacetTargetLink.call(this);
});
function setFacetTargetLink(){
    var facetIdParams = "";
    if($('.js-productfinder').length > 0){
        $(this).closest('ul').find('input:checked').not(this).prop( "checked", false );
    };
    $(this).closest('li').toggleClass('facet-filter-checked');
    if($('.js-productfinder').length > 0){
        
         $(this).closest('.productfinder-col').nextAll('.productfinder-col').each(function(){
            $(this).find('.js-dropdown').addClass('disabled');
            $(this).find('.produktfinder-choose-value').html($(this).find('.js-dropdown-value').data('defaulttxt'));
        })
                
        $nextFacetGroup = $(this).closest('.productfinder-col').next('.productfinder-col');
      
        $nextFacetGroup.find('.jseibel-Chevron').removeClass('jseibel-Chevron').addClass('fa fa-circle-o-notch fa-rotate fa-spin');
        $nextFacetGroup.find('.js-dropdown-content').html('');
    }
    $('[data-eg-facets] input:checked').each(function(index){
        facetIdParams+=$(this).data('eg-facetvalueid') + ",";
    });
    facetIdParams = facetIdParams.slice(0,-1);

    var priceMin = isNaN($('.facet-input-price-min').val()) ? 0 : $('.facet-input-price-min').val();
    var priceMax = isNaN($('.facet-input-price-max').val()) ? 0 : $('.facet-input-price-max').val();
    if($(this).hasClass('facet-remove-price')){
        priceMin = 0;
        priceMax = 0;
        $('.facet-input-price-min').val('');
        $('.facet-input-price-max').val('');
    }

    if($('.forRemove').length>0){
        $('.forRemove').remove()
    }

    var urlParam = {};
    if(priceMin>0 || priceMax>0){
        urlParam["priceMin"] = priceMin;
        urlParam["priceMax"] = priceMax;
    }
    if($('[data-eg-searchstring]').length>0){
        urlParam["query"] = $("[data-eg-facets]").data('eg-searchstring');
    }
    if($('[data-eg-facets] input:checked').length>0){
        urlParam["facets"] = facetIdParams;//encodeURIComponent(facetIdParams);
    }
    if($('.list-sorting').data('eg-activesorting')!=$('.list-sorting').data('eg-defaultsorting')){
        urlParam["sorting"] = $('.list-sorting').data('eg-activesorting');
    }
    if($('.js-productfinder').length > 0){
        var indexdd = $(this).closest('.container-max').find('.nav-link.active').closest('.nav-item').index();
        
        setFacetsProduktfilter(this, urlParam, indexdd);
    }
    var targetSearchUrl = ""
    if($.param(urlParam)!=""){
        if($('.js-productfinder').length > 0){
            var tgurl = $('.js-productfinder').data('searchurlwomen');
            if(indexdd==1){
                tgurl = $('.js-productfinder').data('searchurlmen');
            }
            targetSearchUrl = tgurl+'?'+$.param(urlParam);
        }else{
            targetSearchUrl = window.location.pathname+'?'+$.param(urlParam);
        }

    }else{
        targetSearchUrl = window.location.pathname
    }
    $('[data-eg-btnfilter]').attr('onclick',"document.location.href='"+targetSearchUrl+"'");

    $('[data-eg-btnfilter]').removeClass('btn-load');
   /* if($(this).hasClass('pricefilter')){
        document.location.href = targetSearchUrl;
    }*/
    if($('.js-productfinder').length > 0){
        $(this).closest('.js-dropdown').find('.js-dropdown-value > span:first-child').text($(this).closest('li').find('.facet-item-value').text())
        $(this).closest('.js-dropdown').removeClass('is-open');             
    }

}
function setFacetsProduktfilter(_this, searchParams, indexdd){
    if($(_this).closest('.productfinder-col').next('.productfinder-col').length>0){
        if(indexdd==0){
            searchParams['categoryId'] = 28;
        }else{
            searchParams['categoryId'] = 24;
        }
        
       
        var activeLang = "de";
        var listHtml = "";

        $.get('/'+activeLang+'/rest/io/facet', searchParams, function( data ) {
            var facets = data.data.facets;
            $.each(facets, function(key, val){
                if($nextFacetGroup.data('facetgroupid') == val.id){
                    $nextFacetGroup.find('.js-dropdown').removeClass('disabled');
                    //$nextFacetGroup.find('li').addClass('d-none');
                    listHtml = '<ul class="list-unstyled facetgroup-40">';
                    $.each(val.values, function(key2, val2){
                        listHtml += '<li>';
                        listHtml += '<input id="facet-item-'+val2.id+'" type="checkbox" data-eg-handler="facetFilter" data-eg-facetvalueid="'+val2.id+'" class="hidden-xs-up facet-item-value-chk">';
                        listHtml += '<label for="facet-item-'+val2.id+'" class="facet-item-value d-flex">'+val2.name+'</label>';
                        listHtml += '</li>';
                        //$('.facet-item-value-chk[data-eg-facetvalueid="'+val2.id+'"]').closest('li').removeClass('d-none');                
                    });
                    listHtml+='</ul>';
                    $nextFacetGroup.find('.js-dropdown-content').html(listHtml);
                }

            })
            $nextFacetGroup.find('.fa-circle-o-notch').removeClass('fa fa-circle-o-notch fa-rotate fa-spin').addClass('jseibel-Chevron');
        },'json');
    }
}
$(document).mouseup(function(e) 
{
    var container = $(".js-dropdown");
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        container.removeClass('is-open');
    }
});
/*
$(document).ready(function(e) 
{
    $.get('/rest/nav-item/?herrenId=22&damenId=21', function( data ) {
        var parsedData = JSON.parse(data);
        var NavItemComponentDamen = Vue.extend({
            template: parsedData.data.templateDamen
        })
        Vue.component('navitem-component', NavItemComponentDamen)
        var compiledDamen = new NavItemComponentDamen().$mount();
        $('.placeholder-nav-items-28').html(compiledDamen.$el);

        var NavItemComponentHerren = Vue.extend({
            template: parsedData.data.templateHerren
        })
        Vue.component('navitem-component', NavItemComponentHerren)
        var compiledHerren = new NavItemComponentHerren().$mount();
        $('.placeholder-nav-items-24').html(compiledHerren.$el);
    });

});*/


var timeoutHandle;
var videoIsStart = false;

$(document).ready(function(){
    if($('.page-home-category').length>0){
        window.scrollTo(0, 0);
    }
    
});

//document.addEventListener('touchstart', handler, {passive: true});

$(window).scroll(function()
{
    //if($(window).width()>=992){
        if ($(this).scrollTop() > 1)
        {
            $("body").addClass("sticky");
        }
        else
        {
            $("body").removeClass("sticky");
        }       
    //}
    if($('.video-home').length > 0){
        if($(this).scrollTop() > ($('.video-home').offset().top - 150)){
            if(!videoIsStart){
                $('.js-video').get(0).play();
                videoIsStart = true;
            }
        }
    }
    if($('.modal-nl').length>0){
        if($(window).scrollTop()>800){

            if(getCookie('showModal')==null){
                $('.modal-nl').modal();
                setCookie('showModal','false',1) 
            }
        }
    }
});
function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
window.getCookie = getCookie;
window.setCookie = setCookie;
/*
$('.intro-container').bind('mousewheel DOMMouseScroll', function(event){
    if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
        // scroll up
    }
    else {
        hideIntro();
      
    }
});
var lastY;
$('.intro-container').on({ 'touchstart': function(e) { 
        lastY = e.originalEvent.touches[0].clientY;
    }
});

$('.intro-container').on({ 'touchmove': function(e) { 
        var currentY = e.originalEvent.touches[0].clientY;
        //console.log(e.originalEvent.touches[0])
        if(currentY < lastY){
            hideIntro();
        }
        //lastY = currentY;
    }
});
$(document).on('click','.arrow-intro', function() {
    hideIntro();
});


function hideIntro(){
    $('.vue-app-inner').animate({top: 0 }, 1000,function(){
        $('.intro-container').remove();
        $('body').addClass('introRemoved').removeClass('showIntro');
        setCookie('introCookie','true', 1);
    });
}
*/

/*
$(document).on('input','.input-unit input[type="text"], .input-unit input[type="email"], .input-unit input[type="password"]', function() {
    console.log($(this).val())
    if($(this).val().length>0){
        $(this).closest('.input-unit').addClass('input-has-txt');
    }else{
        $(this).closest('.input-unit').removeClass('input-has-txt');
    }
});*/
$(document).ready(function(){
    if($('.video-home .js-video').length>0){
        var videoHome = $('.video-home .js-video').get(0);
        videoHome.onended = function(e) {
            $('.video-home .js-video').animate({ opacity: 0 }, 1000);
            $('.video-home').addClass('video-end');
            //$('.video-home .video-end-img').fadeIn();
            $('.video-home .video-end-img').animate({ opacity: 1 }, 1000);
            /*setTimeout(function(){ 
                $('.video-home .js-widget-video-txt').animate({ opacity: 1 }, 1000);
            }, 1000); */
        };
        var mediaVideo = $('.no-autoplay .js-video').get(0);
        mediaVideo.onpause = function() {
            $(this).closest('.js-widget-video').find('.js-video-overlay').fadeIn();
            this.controls = false;
        };
    }    
    //$('.home-main-slider').slick();

    
    /*$('.js-image-slider-third').owlCarousel({

    items:1,
    margin:30,
    stagePadding:30,
    smartSpeed:450
    });*/
    
    /*
      var $owl = $('.js-image-slider-third'),
      effect = getAnimationName(),
      outIndex,
      isDragged = false;

  $owl.owlCarousel({
    margin: 0,
    navSpeed: 500,
    nav: true,
    items: 1,
    animateIn: 'fake',
    animateOut: 'fake'
  });

  $owl.on('change.owl.carousel', function(event) {
    outIndex = event.item.index;
  });

  $owl.on('changed.owl.carousel', function(event) {
    var inIndex = event.item.index,
        dir = outIndex <= inIndex ? 'Next' : 'Prev';

    var animation = {
      moveIn: {
        item: $('.owl-item', $owl).eq(inIndex),
        effect: effect + 'In' + dir
      },
      moveOut: {
        item: $('.owl-item', $owl).eq(outIndex),
        effect: effect + 'Out' + dir
      },
      run: function (type) {
        var animationEndEvent = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
            animationObj = this[type],
            inOut = type == 'moveIn' ? 'in' : 'out',
            animationClass = 'animated owl-animated-' + inOut + ' ' + animationObj.effect,
            $nav = $owl.find('.owl-prev, .owl-next, .owl-dot, .owl-stage');

        $nav.css('pointerEvents', 'none');

        animationObj.item.stop().addClass(animationClass).one(animationEndEvent, function () {
          // remove class at the end of the animations
          animationObj.item.removeClass(animationClass);
          $nav.css('pointerEvents', 'auto');
        });
      }
    };

    if (!isDragged){
      animation.run('moveOut');
      animation.run('moveIn');
    }
  });

  $owl.on('drag.owl.carousel', function(event) {
    isDragged = true;
  });

  $owl.on('dragged.owl.carousel', function(event) {
    isDragged = false;
  });*/
})
$(document).on('focus','.input-unit input[type="text"], .input-unit input[type="email"], .input-unit input[type="password"]', function() {
    $(this).closest('.input-unit').addClass('input-has-txt');
});
$(document).on('focusout','.input-unit input[type="text"], .input-unit input[type="email"], .input-unit input[type="password"]', function() {
    if($(this).val().length<=0){
        $(this).closest('.input-unit').removeClass('input-has-txt');
    }
});
$(document).on('focus','.section-newsletter input[type="email"]', function() {
    $(this).closest('.input-unit').addClass('nl-active');
});

$(document).on('focusout','.section-newsletter input[type="email"]', function() {
    if($(this).val().length<=0){
        $(this).closest('.input-unit').removeClass('nl-active');
    }
});
$(document).on('click','.btn-open-oder-details', function() {
   $('.row-orderconfirmation-details').toggleClass('is-open');
   $('.line-hr-details').toggleClass('is-open');
   
});
 

$(document).ready(function(){
    $('input[type="text"]').each(function(){
        if($(this).val().length>0){
            $(this).closest('.input-unit').addClass('input-has-txt');
        }
    });
})
$(document).on("mouseenter",".main-navbar-collapsable .mainmenu > li", function () {
   var _this = this;
   timeoutHandle = setTimeout(function(){ 
        $('body').addClass('hover-menu');
        $(_this).addClass('isHover');
    }, 100);  
});
$(document).on("click",".js-video-overlay", function () {
    var mediaVideo = $(this).closest('.js-widget-video').find('.js-video').get(0);
    
    mediaVideo.play();
    mediaVideo.controls = true;
    $(this).fadeOut();
});

$(document).on("mouseleave",".main-navbar-collapsable .mainmenu > li", function () {
    clearTimeout(timeoutHandle);
    $('body').removeClass('hover-menu');
    $(this).closest('li').removeClass('isHover');
});
$(document).on("click",".search-open-btn", function () {
    $('body').toggleClass('search-open');   
});
$(document).on("click",".footer-title", function () {
    if($(window).width()<768){
        $(this).closest('.footer-content-wrap').toggleClass('active');   
    }
});
$(document).on("click",".btn-open-menu", function () {
    $('body').toggleClass('menu-is-visible'); 
    $('.mobile-navigation').toggleClass('open'); 
});
$(document).on("click",".acc-head", function () {
    if($(window).width()<768){
        
        $(this).closest('.acc-container').toggleClass('active');
        $('.acc-container').not($(this).closest('.acc-container')).removeClass('active');
    }
});
$(document).on("click",".btn-read-more-seo", function () {
    $('.home-seo-inner').toggleClass('is-open');
    if($('.home-seo-inner').hasClass('is-open')){
        $(this).html('Weniger lesen');
    }else{
        $(this).html('Mehr lesen');
    }
});


document.addEventListener("onVariationChanged", function(variation){
    $('.modal-mail-notification-item').attr('data-itemid',variation.detail.itemId);
    $('.modal-mail-notification-item').attr('data-variationid',variation.detail.documents[0].data.variation.id);
    console.log("drinne");
    if($('.config-singleitem').length>0){
        if(Object.keys(orderPropertyData).length>0){
            changeUrl(activeImageUrl);
            setOrderProperties(orderPropertyData, activeImageUrl);
            
        }else{
            /* function from konfigurator.js */
            changeUrl($('.single').data('loadparams'));
            setOrderProperties($('.single').data('orderpropertyvalues'), $('.single').data('loadparams'));
            
        }
        
    }
});
/* CLIENT CONFIG
document.addEventListener("afterBasketItemAdded", function(variation){
    if($('.data-image-create-bsk').length>0){
        createImages('.data-image-create-bsk');
    }
    
});
*/
const cartClass = "fa-shopping-cart";
const loadingClass = "fa-spin fa-circle-o-notch";

document.addEventListener("afterBasketItemAdded", function(response){
    vueApp.$store.dispatch("loadComponent", "basket-preview");
    var dataToAdd = [];
    
    $('.acc-rp-check').each(function(){

        if($(this).is(':checked')){
            const data = {
                variationId : $(this).data('variationid'),
                quantity    : 1,
                basketItemOrderParams: null,
                totalOrderParamsMarkup: null
            };
            dataToAdd.push(data);
        }
    });
    if(dataToAdd.length>0){
        var $addBasketBtn = $('.add-to-basket-container > .btn');
        /*
         * Check if loading class is on button and add it
         */
        const loadInterval = setInterval(function(){
            if(!$addBasketBtn.find('.fa').hasClass('fa-circle-o-notch')){
                $addBasketBtn.attr('disabled','disabled');
                $addBasketBtn.find('.fa').removeClass(cartClass);
                $addBasketBtn.find('.fa').addClass(loadingClass);
                clearInterval(loadInterval);
            }
        }, 10);
        
        const requestAdd = [];
        requestAdd.push(addItemBasket(dataToAdd));
        
        $.when.apply($, requestAdd).done(function(){
              
                document.body.classList.toggle("basket-open");
                $addBasketBtn.removeAttr('disabled');
                $addBasketBtn.find('.fa').removeClass(loadingClass);
                $addBasketBtn.find('.fa').addClass(cartClass);
            
            
        });
    }else{
        document.body.classList.toggle("basket-open");
    }
})
async function handleBasketData(basketItemData){
    for (const basketData of basketItemData) {
        await addItemBasket(basketData);
    }
}
async function addItemBasket(basketItemData){
    for (const basketData of basketItemData) {
        await vueApp.$store.dispatch("addBasketItem", basketData);
    }   
}
$(document).ajaxComplete(function(event,request, settings){

    if(settings.url == "/rest/io/customer/newsletter/"){
        
        const urlParams = new URLSearchParams(settings.data); 
        const mailFolderMapping = {
            "1": "Damen",
            "2": "Herren",
            "5": "Divers"
        }
        
        var postData = {
            "email": urlParams.get('email'),
            "salutation": mailFolderMapping[urlParams.get('emailFolder')],
            "first_name": urlParams.get('firstName'),
            "last_name":  urlParams.get('lastName')
        }

        $.ajax({
            url: "/sendNlData/",
            type: "post",
            data: postData,
            success: function(response) {
                console.log(response);
            },
            error: function(xhr) {
                console.log(xhr);
            }
        });
    }
    if(settings.url == "/rest/io/customer/contact/mail/"){

        const urlParams = new URLSearchParams(settings.data); 
        
        var postData = {
            "email": urlParams.get('data[E-Mail][value]'),
            "salutation": urlParams.get('data[Geschlecht][value]'),
            "first_name": urlParams.get('data[Vorname][value]'),
            "last_name":  urlParams.get('data[Nachname][value]'),
            "isB2B": false
        }
        console.log(urlParams)
        if($('.category-28').length > 0){
            var postData = {
                "email": urlParams.get('data[E-Mail][value]'),
                "salutation": urlParams.get('data[Geschlecht][value]'),
                "first_name": urlParams.get('data[Vorname][value]'),
                "last_name":  urlParams.get('data[Nachname][value]'),
                "country":  urlParams.get('data[Land][value]'),
                "firma": urlParams.get('data[Firma][value]'),
                "phone": urlParams.get('data[Telefon][value]'),
                "isB2B": true
            }
        }
        
        
        $.ajax({
            url: "/sendContactData/",
            type: "post",
            data: postData,
            success: function(response) {
                console.log(response);
            },
            error: function(xhr) {
                console.log(xhr);
            }
        });
    }
});

$(document).on("click",".stock-notification", function () {
    $('.modal-mail-notification-item').attr('data-itemid',vueApp.$store.state.items.mainItemId);
    $('.modal-mail-notification-item').attr('data-variationid',vueApp.$store.state.items[vueApp.$store.state.items.mainItemId].variation.documents[0].id);
    $('.modal-mail-notification-item').modal();
  
});

$(document).on("click",".switch-eu-sizes > button", function () {
    $('.switch-eu-sizes > button').removeClass('active');
    $(this).addClass('active');
    $('.size-value').attr('data-sizemapping',$(this).data('sizemapping'));
});
$(document).on("click",".expandCookibannerSettings", function () {
    $('.cookie-bar [data-cb="collapseIn"] [data-cb="expand"]')[0].click();
});



$(document).on("click",".switch-box-clickable", function () {
    $(this).closest('.vertical-column-clickable').toggleClass('flipped');
});

$(document).on("click",".btn-send-mail-notification", function () {
    var postParams = {
        productid: $('.modal-mail-notification-item').attr('data-itemid'),
        variationid: $('.modal-mail-notification-item').attr('data-variationid'),
        shoplanguage: 'de',
        email: $('.input-mail-notification').val()
    };
    $.ajax({
        url: "/notification-optin/",
        type: "post",
        data: postParams
    }).done(function(data) {
        $('.log-notification-mail').html(data);
    });
});

$(document).on("click",".filter-values-head", function () {
    $(this).closest('.filter-values').toggleClass('single-filter-open') 
});

/** SLIDER **/
function initSliderScripts(){
    if($('.js-image-slider-special-item-1').length >0){
        $('.js-image-slider-special-item-1').slick({
            draggable: true,
            arrows: false,
            dots: false,
            speed: 1000,
            infinite: true,
            cssEase: 'cubic-bezier(0.76, 0, 0.24, 1)',
            touchThreshold: 100,
            asNavFor: '.js-image-slider-special-item-2, .js-image-slider-special-item-3',
            waitForAnimate: true,
            lazyLoad: 'ondemand'
        });
    }
    if($('.js-image-slider-special-item-2').length >0){
        $('.js-image-slider-special-item-2').slick({
            draggable: true,
            arrows: false,
            dots: false,
            speed: 1500,
            infinite: true,
            cssEase: 'cubic-bezier(0.76, 0, 0.24, 1)',
            touchThreshold: 100,
            asNavFor: '.js-image-slider-special-item-1, .js-image-slider-special-item-3',
            waitForAnimate: true,
            lazyLoad: 'ondemand'
        });
    }
    if($('.js-image-slider-special-item-3').length >0){
        $('.js-image-slider-special-item-3').slick({
            draggable: true,
            arrows: false,
            dots: true,
            speed: 1800,
            infinite: true,
           /* customPaging : function(slider, i) {
                var thumb = $('.nav-for-image-slider-special').find('button');
                return thumb;
           },*/
            cssEase: 'cubic-bezier(0.76, 0, 0.24, 1)',
            touchThreshold: 100,
            appendDots: '.nav-for-image-slider-special',
            asNavFor: '.js-image-slider-special-item-1, .js-image-slider-special-item-2',
            waitForAnimate: true,
            autoplay: true,
            autoplaySpeed: 3000,
            lazyLoad: 'ondemand'
        });
    }
    
 


    $('.js-image-slider-special-item-1, .js-image-slider-special-item-2, .js-image-slider-special-item-3').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        var nextSlide = slick.$slides.get(nextSlide);
        var $slideSoureSets = $(nextSlide).find('source');
        $($slideSoureSets).each(function () {
            $(this).attr('srcset', $(this).data('lazy'));
        });
    });  
    $('.js-image-slider-special-item-1').on('afterChange', function(event, slick, currentSlide, nextSlide){
        $('.js-image-slider-special-wrap').find('.slider-special-txt-block').removeClass('active');
        $('.js-image-slider-special-wrap').find('.slider-special-txt-block[data-txtslidecount="'+currentSlide+'"]').addClass('active');
    });
    if($('.js-widget-item-list-slider').length>0){
        $('.js-widget-item-list-slider').owlCarousel({
            margin:0,
            loop:false,
            autoWidth:true,
            items:4,
            dots: false,
            nav: true,
            navText: ['<span class="jseibel-Arrow"></span>','<span class="jseibel-Arrow"></span>']
        });
    }

    $('.js-widget-item-list-slider-widget').each(function(){
            var itemRow = $(this).data('itemsrow');
            new Splide(this, {
                
                fixedWidth: '200px',
                drag   : 'free',
                gap    : '16px',
                mediaQuery: 'min',
                arrows: true,
                pagination: false,
                omitEnd  : true,
                breakpoints:{
                    
                    768: {
                        autoWidth: false,
                        perPage: itemRow,
                        fixedWidth: false,
                    },
                    992: {
                        gap    : '40px',
                    }
                }
            }).mount();
    })
    /*
    $('.js-widget-item-list-slider-widget').each(function(){
        var itemRow = $(this).data('itemsrow');
        $(this).owlCarousel({
            margin:0,
            loop:false,
            autoWidth:false,
            items:2,
            dots: false,
            nav: true,
            navText: ['<span class="jseibel-Arrow"></span>','<span class="jseibel-Arrow"></span>'],
            responsive : {
                768 : {
                    items: itemRow,
                }
            }
        }); 
    })*/

    if($('.js-image-slider:not(.slider-tab)').length > 0){
        $('.js-image-slider:not(.slider-tab)').owlCarousel({
            items:1,
            loop:true,
            autoplay:true,
            autoplayTimeout:3000,
            onInitialized: function(event){
                $(event.currentTarget).closest('.js-image-slider-wrap').addClass('slider-loaded');
            }
        });
    }
    
    if($('.slider-tab').length>0){
        $('.slider-tab').owlCarousel({
            items:1,
            loop:true,
            animateOut: 'fadeOut',
            animateIn: 'fadeIn',
            nav: false,
            dots:false,
            smartSpeed: 0,
            fluidSpeed: 0,
            autoplay:true,
            autoplayTimeout:2000,
            onInitialized: function(event){
                $(event.currentTarget).closest('.js-image-slider-wrap').addClass('slider-loaded');
            }
        });
    }
}
$(document).ready(function(){
    $('<a href="javascript:void(0)" class="btn btn-link pl-0 pr-0 mb-3 expandCookibannerSettings"><span>'+globalCookieSubtitle+'</span></a>').insertBefore('.cookie-bar [data-cb="collapseIn"] [data-cb="acceptAll"]');
    $('<p class="h4 mb-3">'+globalCookieSettings+'</p>').insertBefore('.cookie-bar [data-cb="collapseIn"] .cookie-bar__message');
    $('.cookie-bar [data-cb="save"]').addClass('btn-secondary');
    setTimeout(function(){
        $('.cookie-bar').addClass('after-cookie-wait')
    }, 3000);
});
if($('.splide-slider-cats').length > 0){
    new Splide('.splide-slider-cats', {
        fixedWidth: '200px',
        drag   : 'free',
        gap    : '5px',
        mediaQuery: 'min',
        pagination: false,
        arrows: false,
        breakpoints:{
            768: {
                perPage: 3,
                fixedWidth: false,
                arrows: true
            },
            992: {
                perPage: 4,
                fixedWidth: false,
                arrows: true
            },
        }
        }).mount(); 
}
/*** SINGLEITEM ***/
var observer;
document.onreadystatechange = function () {
if (document.readyState == "complete") {  
        /*observer = lozad('.js-lozad',{
            load: function(el) {
                if(el.tagName.toLowerCase() == "picture"){
                    $(el).find('source').each(function(){$(this).attr('srcset', $(this).attr('data-srcset'))})
                    $(el).find('img').each(function(){$(this).attr('src', $(this).attr('data-src'))})
                }else if(el.tagName.toLowerCase() == "video"){
                    $(el).find('source').each(function(){$(this).attr('src', $(this).attr('data-src'))})
                    $(el).attr('poster', $(el).attr('data-poster'));
                    $(el).get(0).load();
                }else{
                    $(el).attr('src', $(el).attr('data-src'));
                }
                
              }
        }); 
        observer.observe();*/
        initSliderScripts();
        if($('.single').length>0){
           initSingleScripts();
           var ombibusRatingTxt = `<div class="omnibus-rating"><p class="mb-1">${omnibusRatingTitle}</p>${omnibusRatingText}</div>`;
           $('#ekomi_prc_tab .ekomi-widget-container').before(ombibusRatingTxt);
        }
        if($('.config-singleitem').length>0){
            /* function from konfigurator.js */
            setOrderProperties($('.single').data('orderpropertyvalues'), $('.single').data('loadparams'));
        }
        
    }
}
$(document).on("click",".btn-read-more", function () {
    
    var $element = $(this).closest('.item-description-read-more-wrap').find('.item-description-read-more-content');
    if($(this).closest('.item-description-read-more-wrap').hasClass('is-open')){
        if(window.innerWidth >= 768){
            $element.animate({ height: '230px' }, 500);
        }else{
            $element.animate({ height: '310px' }, 500);
        }
        var $target = $('.item-description-read-more-wrap');
        $('html, body').animate({
            scrollTop: $target.offset().top - $('.default-header').height()
        }, 500); 
    }else{
        $element.css('height', 'auto');
        var height = $element.height(); // Messen der tatsächlichen Höhe
        $element.css('height', '0px').css('display', 'block');
        $element.animate({ height: height }, 500,function(){
            $element.css('height', 'auto');
        });
        
        
    }
    $(this).closest('.item-description-read-more-wrap').toggleClass('is-open');
});

function initSingleScripts(){
    if($('.single-property-wrap').length > 0 && $('.single-property-wrap').find('.single-property-item-img').length > 0){
        $('.single-property-wrap').owlCarousel({
            margin:0,
            loop:false,
            autoWidth:true,
            items:5,
            dots: false,
            nav: false,
            navText: ['<span class="jseibel-Arrow"></span>','<span class="jseibel-Arrow"></span>'],
            responsive : {
                992 : {
                    nav: true
                }
            }
        });
    }
    
    if($('.item-slider-banner').length>0){
        $('.item-slider-banner').owlCarousel({
            margin:0,
            loop:false,
            autoplay:true,
            autoplayTimeout:3000,
            dots: false,
            nav: true,
            lazyLoad:true,
            navText: ['<span class="jseibel-Arrow"></span>','<span class="jseibel-Arrow"></span>']
        });
    }



    MagicZoom.start('jsMagic0');  
    MagicZoom.registerCallback('onUpdate', 
        function() {
            updateMagicIndex($(arguments[2]).data('zoomindex'));
            
            //console.log('onUpdated', arguments[0], arguments[1], arguments[2]);
        });

}
function updateMagicIndex(magicIndex){
    $('.dots-magic span').removeClass('is-active');
    $(`.dots-magic span[data-magicindex=${magicIndex}]`).addClass('is-active');
}
$(document).on('click','.arrow-magic', function() {
    if($(this).hasClass('arrow-magic-prev')){
        MagicZoom.prev('jsMagic0')
    }else{
        MagicZoom.next('jsMagic0')
    }
    updateMagicIndex($('.js-item-image .mz-thumb-selected').data('zoomindex')); 
    
});
$(document).on('click','.dots-magic span', function() {
    var dotIndex = $(this).data('magicindex');
    updateMagicIndex(dotIndex); 
    MagicZoom.switchTo('jsMagic0', dotIndex);
});


(function($) {
    $.fn.textWidth = function(){
         var calc = '<span style="display:none">' + $(this).text() + '</span>';
         $('body').append(calc);
         var width = $('body').find('span:last').width();
         $('body').find('span:last').remove();
        return width;
    };

    $.fn.marquee = function(args) {
        var that = $(this);
        var textWidth = that.textWidth(),
            offset = that.width(),
            width = offset,
            css = {
                'text-indent' : that.css('text-indent'),
                'overflow' : that.css('overflow'),
                'white-space' : that.css('white-space')
            },
            marqueeCss = {
                'text-indent' : width,
                'overflow' : 'hidden',
                'white-space' : 'nowrap'
            },
            args = $.extend(true, { count: -1, speed: 1e1, leftToRight: false }, args),
            i = 0,
            stop = textWidth*-1,
            dfd = $.Deferred();

        function go() {
            if(!that.length) return dfd.reject();
            if(width == stop) {
                i++;
                if(i == args.count) {
                    that.css(css);
                    return dfd.resolve();
                }
                if(args.leftToRight) {
                    width = textWidth*-1;
                } else {
                    width = offset;
                }
            }
            that.css('text-indent', width + 'px');
            if(args.leftToRight) {
                width++;
            } else {
                width--;
            }
            setTimeout(go, args.speed);
        };
        if(args.leftToRight) {
            width = textWidth*-1;
            width++;
            stop = offset;
        } else {
            width--;            
        }
        that.css(marqueeCss);
        go();
        return dfd.promise();
    };
})(jQuery);
/*
if(vueApp.$store.getters.currentItemVariation != undefined){
    var needAddBasket = false;
    var currentVariationid = vueApp.$store.getters.currentItemVariation.variation.id;
    window.addEventListener('fpt-add-to-cart', function (event) {
    
        needAddBasket = true;
        vueApp.$store.dispatch("loadComponent", "basket-preview");
        $('.variation-dropdown-content .v-s-box').each(function(){
            if($(this).find('.size-eu').text() == event.detail.size.value){
                console.log(event.detail.size.value)
                $('.variation-dropdown-content .v-s-box').removeClass('active');
                $(this).addClass('active').trigger('click');
                $(this)[0].dispatchEvent(new Event("click"));//.trigger('click');
                //vueApp.$store.getters.currentItemVariation.variation.id
            }
           
        });
        if(currentVariationid == vueApp.$store.getters.currentItemVariation.variation.id){
            if(needAddBasket){
                footPrintAddBasket();
                needAddBasket = false;
            }
        }else{
            document.addEventListener("onVariationChanged", function(variation){
                if(needAddBasket){
                    currentVariationid = vueApp.$store.getters.currentItemVariation.variation.id;
                    footPrintAddBasket();
                    needAddBasket = false;
                }
                
            });
        }
        localStorage.setItem('footprint-sessionid', event.detail.session_id);

        console.log(event);
    });
    window.addEventListener('fpt-back-to-shop', function (event) {
        localStorage.setItem('footprint-sessionid', event.detail.session_id);
    });
    window.addEventListener('fpt-cancel', function (event) {
        localStorage.setItem('footprint-sessionid', event.detail.session_id);
    });
}

function footPrintAddBasket(){
    vueApp.$store.dispatch("loadComponent", "add-item-to-basket-overlay");
    vueApp.$store.commit("setIsAddToBasketLoading", vueApp.$store.getters.currentItemVariation.variation.id);
    const basketData = {
        variationId : vueApp.$store.getters.currentItemVariation.variation.id,
        quantity    : 1,
        basketItemOrderParams: null,
        totalOrderParamsMarkup: null
    };
    vueApp.$store.dispatch("addBasketItem", basketData).then(function(){
        vueApp.$store.commit("setIsAddToBasketLoading", 0);
    });
}
window.footPrintAddBasket = footPrintAddBasket;*/
//window.destroyZoom = destroyZoom;
//window.initZoom = initZoom;
window.updateMagicIndex = updateMagicIndex;


/* SLICK */
(function(factory){"use strict";if(typeof define==="function"&&define.amd){define(["jquery"],factory)}else if(typeof exports!=="undefined"){module.exports=factory(require("jquery"))}else{factory(jQuery)}})(function($){"use strict";var Slick=window.Slick||{};Slick=function(){var instanceUid=0;function Slick(element,settings){var _=this,dataSettings;_.defaults={accessibility:true,adaptiveHeight:false,appendArrows:$(element),appendDots:$(element),arrows:true,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:false,autoplaySpeed:3e3,centerMode:false,centerPadding:"50px",cssEase:"ease",customPaging:function(slider,i){return $('<button type="button" />').text(i+1)},dots:false,dotsClass:"slick-dots",draggable:true,easing:"linear",edgeFriction:.35,fade:false,focusOnSelect:false,focusOnChange:false,infinite:true,initialSlide:0,lazyLoad:"ondemand",mobileFirst:false,pauseOnHover:true,pauseOnFocus:true,pauseOnDotsHover:false,respondTo:"window",responsive:null,rows:1,rtl:false,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:true,swipeToSlide:false,touchMove:true,touchThreshold:5,useCSS:true,useTransform:true,variableWidth:false,vertical:false,verticalSwiping:false,waitForAnimate:true,zIndex:1e3};_.initials={animating:false,dragging:false,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:false,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:false,slideOffset:0,swipeLeft:null,swiping:false,$list:null,touchObject:{},transformsEnabled:false,unslicked:false};$.extend(_,_.initials);_.activeBreakpoint=null;_.animType=null;_.animProp=null;_.breakpoints=[];_.breakpointSettings=[];_.cssTransitions=false;_.focussed=false;_.interrupted=false;_.hidden="hidden";_.paused=true;_.positionProp=null;_.respondTo=null;_.rowCount=1;_.shouldClick=true;_.$slider=$(element);_.$slidesCache=null;_.transformType=null;_.transitionType=null;_.visibilityChange="visibilitychange";_.windowWidth=0;_.windowTimer=null;dataSettings=$(element).data("slick")||{};_.options=$.extend({},_.defaults,settings,dataSettings);_.currentSlide=_.options.initialSlide;_.originalSettings=_.options;if(typeof document.mozHidden!=="undefined"){_.hidden="mozHidden";_.visibilityChange="mozvisibilitychange"}else if(typeof document.webkitHidden!=="undefined"){_.hidden="webkitHidden";_.visibilityChange="webkitvisibilitychange"}_.autoPlay=$.proxy(_.autoPlay,_);_.autoPlayClear=$.proxy(_.autoPlayClear,_);_.autoPlayIterator=$.proxy(_.autoPlayIterator,_);_.changeSlide=$.proxy(_.changeSlide,_);_.clickHandler=$.proxy(_.clickHandler,_);_.selectHandler=$.proxy(_.selectHandler,_);_.setPosition=$.proxy(_.setPosition,_);_.swipeHandler=$.proxy(_.swipeHandler,_);_.dragHandler=$.proxy(_.dragHandler,_);_.keyHandler=$.proxy(_.keyHandler,_);_.instanceUid=instanceUid++;_.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/;_.registerBreakpoints();_.init(true)}return Slick}();Slick.prototype.activateADA=function(){var _=this;_.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})};Slick.prototype.addSlide=Slick.prototype.slickAdd=function(markup,index,addBefore){var _=this;if(typeof index==="boolean"){addBefore=index;index=null}else if(index<0||index>=_.slideCount){return false}_.unload();if(typeof index==="number"){if(index===0&&_.$slides.length===0){$(markup).appendTo(_.$slideTrack)}else if(addBefore){$(markup).insertBefore(_.$slides.eq(index))}else{$(markup).insertAfter(_.$slides.eq(index))}}else{if(addBefore===true){$(markup).prependTo(_.$slideTrack)}else{$(markup).appendTo(_.$slideTrack)}}_.$slides=_.$slideTrack.children(this.options.slide);_.$slideTrack.children(this.options.slide).detach();_.$slideTrack.append(_.$slides);_.$slides.each(function(index,element){$(element).attr("data-slick-index",index)});_.$slidesCache=_.$slides;_.reinit()};Slick.prototype.animateHeight=function(){var _=this;if(_.options.slidesToShow===1&&_.options.adaptiveHeight===true&&_.options.vertical===false){var targetHeight=_.$slides.eq(_.currentSlide).outerHeight(true);_.$list.animate({height:targetHeight},_.options.speed)}};Slick.prototype.animateSlide=function(targetLeft,callback){var animProps={},_=this;_.animateHeight();if(_.options.rtl===true&&_.options.vertical===false){targetLeft=-targetLeft}if(_.transformsEnabled===false){if(_.options.vertical===false){_.$slideTrack.animate({left:targetLeft},_.options.speed,_.options.easing,callback)}else{_.$slideTrack.animate({top:targetLeft},_.options.speed,_.options.easing,callback)}}else{if(_.cssTransitions===false){if(_.options.rtl===true){_.currentLeft=-_.currentLeft}$({animStart:_.currentLeft}).animate({animStart:targetLeft},{duration:_.options.speed,easing:_.options.easing,step:function(now){now=Math.ceil(now);if(_.options.vertical===false){animProps[_.animType]="translate("+now+"px, 0px)";_.$slideTrack.css(animProps)}else{animProps[_.animType]="translate(0px,"+now+"px)";_.$slideTrack.css(animProps)}},complete:function(){if(callback){callback.call()}}})}else{_.applyTransition();targetLeft=Math.ceil(targetLeft);if(_.options.vertical===false){animProps[_.animType]="translate3d("+targetLeft+"px, 0px, 0px)"}else{animProps[_.animType]="translate3d(0px,"+targetLeft+"px, 0px)"}_.$slideTrack.css(animProps);if(callback){setTimeout(function(){_.disableTransition();callback.call()},_.options.speed)}}}};Slick.prototype.getNavTarget=function(){var _=this,asNavFor=_.options.asNavFor;if(asNavFor&&asNavFor!==null){asNavFor=$(asNavFor).not(_.$slider)}return asNavFor};Slick.prototype.asNavFor=function(index){var _=this,asNavFor=_.getNavTarget();if(asNavFor!==null&&typeof asNavFor==="object"){asNavFor.each(function(){var target=$(this).slick("getSlick");if(!target.unslicked){target.slideHandler(index,true)}})}};Slick.prototype.applyTransition=function(slide){var _=this,transition={};if(_.options.fade===false){transition[_.transitionType]=_.transformType+" "+_.options.speed+"ms "+_.options.cssEase}else{transition[_.transitionType]="opacity "+_.options.speed+"ms "+_.options.cssEase}if(_.options.fade===false){_.$slideTrack.css(transition)}else{_.$slides.eq(slide).css(transition)}};Slick.prototype.autoPlay=function(){var _=this;_.autoPlayClear();if(_.slideCount>_.options.slidesToShow){_.autoPlayTimer=setInterval(_.autoPlayIterator,_.options.autoplaySpeed)}};Slick.prototype.autoPlayClear=function(){var _=this;if(_.autoPlayTimer){clearInterval(_.autoPlayTimer)}};Slick.prototype.autoPlayIterator=function(){var _=this,slideTo=_.currentSlide+_.options.slidesToScroll;if(!_.paused&&!_.interrupted&&!_.focussed){if(_.options.infinite===false){if(_.direction===1&&_.currentSlide+1===_.slideCount-1){_.direction=0}else if(_.direction===0){slideTo=_.currentSlide-_.options.slidesToScroll;if(_.currentSlide-1===0){_.direction=1}}}_.slideHandler(slideTo)}};Slick.prototype.buildArrows=function(){var _=this;if(_.options.arrows===true){_.$prevArrow=$(_.options.prevArrow).addClass("slick-arrow");_.$nextArrow=$(_.options.nextArrow).addClass("slick-arrow");if(_.slideCount>_.options.slidesToShow){_.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex");_.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex");if(_.htmlExpr.test(_.options.prevArrow)){_.$prevArrow.prependTo(_.options.appendArrows)}if(_.htmlExpr.test(_.options.nextArrow)){_.$nextArrow.appendTo(_.options.appendArrows)}if(_.options.infinite!==true){_.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")}}else{_.$prevArrow.add(_.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"})}}};Slick.prototype.buildDots=function(){var _=this,i,dot;if(_.options.dots===true&&_.slideCount>_.options.slidesToShow){_.$slider.addClass("slick-dotted");dot=$("<ul />").addClass(_.options.dotsClass);for(i=0;i<=_.getDotCount();i+=1){dot.append($("<li />").append(_.options.customPaging.call(this,_,i)))}_.$dots=dot.appendTo(_.options.appendDots);_.$dots.find("li").first().addClass("slick-active")}};Slick.prototype.buildOut=function(){var _=this;_.$slides=_.$slider.children(_.options.slide+":not(.slick-cloned)").addClass("slick-slide");_.slideCount=_.$slides.length;_.$slides.each(function(index,element){$(element).attr("data-slick-index",index).data("originalStyling",$(element).attr("style")||"")});_.$slider.addClass("slick-slider");_.$slideTrack=_.slideCount===0?$('<div class="slick-track"/>').appendTo(_.$slider):_.$slides.wrapAll('<div class="slick-track"/>').parent();_.$list=_.$slideTrack.wrap('<div class="slick-list"/>').parent();_.$slideTrack.css("opacity",0);if(_.options.centerMode===true||_.options.swipeToSlide===true){_.options.slidesToScroll=1}$("img[data-lazy]",_.$slider).not("[src]").addClass("slick-loading");_.setupInfinite();_.buildArrows();_.buildDots();_.updateDots();_.setSlideClasses(typeof _.currentSlide==="number"?_.currentSlide:0);if(_.options.draggable===true){_.$list.addClass("draggable")}};Slick.prototype.buildRows=function(){var _=this,a,b,c,newSlides,numOfSlides,originalSlides,slidesPerSection;newSlides=document.createDocumentFragment();originalSlides=_.$slider.children();if(_.options.rows>0){slidesPerSection=_.options.slidesPerRow*_.options.rows;numOfSlides=Math.ceil(originalSlides.length/slidesPerSection);for(a=0;a<numOfSlides;a++){var slide=document.createElement("div");for(b=0;b<_.options.rows;b++){var row=document.createElement("div");for(c=0;c<_.options.slidesPerRow;c++){var target=a*slidesPerSection+(b*_.options.slidesPerRow+c);if(originalSlides.get(target)){row.appendChild(originalSlides.get(target))}}slide.appendChild(row)}newSlides.appendChild(slide)}_.$slider.empty().append(newSlides);_.$slider.children().children().children().css({width:100/_.options.slidesPerRow+"%",display:"inline-block"})}};Slick.prototype.checkResponsive=function(initial,forceUpdate){var _=this,breakpoint,targetBreakpoint,respondToWidth,triggerBreakpoint=false;var sliderWidth=_.$slider.width();var windowWidth=window.innerWidth||$(window).width();if(_.respondTo==="window"){respondToWidth=windowWidth}else if(_.respondTo==="slider"){respondToWidth=sliderWidth}else if(_.respondTo==="min"){respondToWidth=Math.min(windowWidth,sliderWidth)}if(_.options.responsive&&_.options.responsive.length&&_.options.responsive!==null){targetBreakpoint=null;for(breakpoint in _.breakpoints){if(_.breakpoints.hasOwnProperty(breakpoint)){if(_.originalSettings.mobileFirst===false){if(respondToWidth<_.breakpoints[breakpoint]){targetBreakpoint=_.breakpoints[breakpoint]}}else{if(respondToWidth>_.breakpoints[breakpoint]){targetBreakpoint=_.breakpoints[breakpoint]}}}}if(targetBreakpoint!==null){if(_.activeBreakpoint!==null){if(targetBreakpoint!==_.activeBreakpoint||forceUpdate){_.activeBreakpoint=targetBreakpoint;if(_.breakpointSettings[targetBreakpoint]==="unslick"){_.unslick(targetBreakpoint)}else{_.options=$.extend({},_.originalSettings,_.breakpointSettings[targetBreakpoint]);if(initial===true){_.currentSlide=_.options.initialSlide}_.refresh(initial)}triggerBreakpoint=targetBreakpoint}}else{_.activeBreakpoint=targetBreakpoint;if(_.breakpointSettings[targetBreakpoint]==="unslick"){_.unslick(targetBreakpoint)}else{_.options=$.extend({},_.originalSettings,_.breakpointSettings[targetBreakpoint]);if(initial===true){_.currentSlide=_.options.initialSlide}_.refresh(initial)}triggerBreakpoint=targetBreakpoint}}else{if(_.activeBreakpoint!==null){_.activeBreakpoint=null;_.options=_.originalSettings;if(initial===true){_.currentSlide=_.options.initialSlide}_.refresh(initial);triggerBreakpoint=targetBreakpoint}}if(!initial&&triggerBreakpoint!==false){_.$slider.trigger("breakpoint",[_,triggerBreakpoint])}}};Slick.prototype.changeSlide=function(event,dontAnimate){var _=this,$target=$(event.currentTarget),indexOffset,slideOffset,unevenOffset;if($target.is("a")){event.preventDefault()}if(!$target.is("li")){$target=$target.closest("li")}unevenOffset=_.slideCount%_.options.slidesToScroll!==0;indexOffset=unevenOffset?0:(_.slideCount-_.currentSlide)%_.options.slidesToScroll;switch(event.data.message){case"previous":slideOffset=indexOffset===0?_.options.slidesToScroll:_.options.slidesToShow-indexOffset;if(_.slideCount>_.options.slidesToShow){_.slideHandler(_.currentSlide-slideOffset,false,dontAnimate)}break;case"next":slideOffset=indexOffset===0?_.options.slidesToScroll:indexOffset;if(_.slideCount>_.options.slidesToShow){_.slideHandler(_.currentSlide+slideOffset,false,dontAnimate)}break;case"index":var index=event.data.index===0?0:event.data.index||$target.index()*_.options.slidesToScroll;_.slideHandler(_.checkNavigable(index),false,dontAnimate);$target.children().trigger("focus");break;default:return}};Slick.prototype.checkNavigable=function(index){var _=this,navigables,prevNavigable;navigables=_.getNavigableIndexes();prevNavigable=0;if(index>navigables[navigables.length-1]){index=navigables[navigables.length-1]}else{for(var n in navigables){if(index<navigables[n]){index=prevNavigable;break}prevNavigable=navigables[n]}}return index};Slick.prototype.cleanUpEvents=function(){var _=this;if(_.options.dots&&_.$dots!==null){$("li",_.$dots).off("click.slick",_.changeSlide).off("mouseenter.slick",$.proxy(_.interrupt,_,true)).off("mouseleave.slick",$.proxy(_.interrupt,_,false));if(_.options.accessibility===true){_.$dots.off("keydown.slick",_.keyHandler)}}_.$slider.off("focus.slick blur.slick");if(_.options.arrows===true&&_.slideCount>_.options.slidesToShow){_.$prevArrow&&_.$prevArrow.off("click.slick",_.changeSlide);_.$nextArrow&&_.$nextArrow.off("click.slick",_.changeSlide);if(_.options.accessibility===true){_.$prevArrow&&_.$prevArrow.off("keydown.slick",_.keyHandler);_.$nextArrow&&_.$nextArrow.off("keydown.slick",_.keyHandler)}}_.$list.off("touchstart.slick mousedown.slick",_.swipeHandler);_.$list.off("touchmove.slick mousemove.slick",_.swipeHandler);_.$list.off("touchend.slick mouseup.slick",_.swipeHandler);_.$list.off("touchcancel.slick mouseleave.slick",_.swipeHandler);_.$list.off("click.slick",_.clickHandler);$(document).off(_.visibilityChange,_.visibility);_.cleanUpSlideEvents();if(_.options.accessibility===true){_.$list.off("keydown.slick",_.keyHandler)}if(_.options.focusOnSelect===true){$(_.$slideTrack).children().off("click.slick",_.selectHandler)}$(window).off("orientationchange.slick.slick-"+_.instanceUid,_.orientationChange);$(window).off("resize.slick.slick-"+_.instanceUid,_.resize);$("[draggable!=true]",_.$slideTrack).off("dragstart",_.preventDefault);$(window).off("load.slick.slick-"+_.instanceUid,_.setPosition)};Slick.prototype.cleanUpSlideEvents=function(){var _=this;_.$list.off("mouseenter.slick",$.proxy(_.interrupt,_,true));_.$list.off("mouseleave.slick",$.proxy(_.interrupt,_,false))};Slick.prototype.cleanUpRows=function(){var _=this,originalSlides;if(_.options.rows>0){originalSlides=_.$slides.children().children();originalSlides.removeAttr("style");_.$slider.empty().append(originalSlides)}};Slick.prototype.clickHandler=function(event){var _=this;if(_.shouldClick===false){event.stopImmediatePropagation();event.stopPropagation();event.preventDefault()}};Slick.prototype.destroy=function(refresh){var _=this;_.autoPlayClear();_.touchObject={};_.cleanUpEvents();$(".slick-cloned",_.$slider).detach();if(_.$dots){_.$dots.remove()}if(_.$prevArrow&&_.$prevArrow.length){_.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display","");if(_.htmlExpr.test(_.options.prevArrow)){_.$prevArrow.remove()}}if(_.$nextArrow&&_.$nextArrow.length){_.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display","");if(_.htmlExpr.test(_.options.nextArrow)){_.$nextArrow.remove()}}if(_.$slides){_.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){$(this).attr("style",$(this).data("originalStyling"))});_.$slideTrack.children(this.options.slide).detach();_.$slideTrack.detach();_.$list.detach();_.$slider.append(_.$slides)}_.cleanUpRows();_.$slider.removeClass("slick-slider");_.$slider.removeClass("slick-initialized");_.$slider.removeClass("slick-dotted");_.unslicked=true;if(!refresh){_.$slider.trigger("destroy",[_])}};Slick.prototype.disableTransition=function(slide){var _=this,transition={};transition[_.transitionType]="";if(_.options.fade===false){_.$slideTrack.css(transition)}else{_.$slides.eq(slide).css(transition)}};Slick.prototype.fadeSlide=function(slideIndex,callback){var _=this;if(_.cssTransitions===false){_.$slides.eq(slideIndex).css({zIndex:_.options.zIndex});_.$slides.eq(slideIndex).animate({opacity:1},_.options.speed,_.options.easing,callback)}else{_.applyTransition(slideIndex);_.$slides.eq(slideIndex).css({opacity:1,zIndex:_.options.zIndex});if(callback){setTimeout(function(){_.disableTransition(slideIndex);callback.call()},_.options.speed)}}};Slick.prototype.fadeSlideOut=function(slideIndex){var _=this;if(_.cssTransitions===false){_.$slides.eq(slideIndex).animate({opacity:0,zIndex:_.options.zIndex-2},_.options.speed,_.options.easing)}else{_.applyTransition(slideIndex);_.$slides.eq(slideIndex).css({opacity:0,zIndex:_.options.zIndex-2})}};Slick.prototype.filterSlides=Slick.prototype.slickFilter=function(filter){var _=this;if(filter!==null){_.$slidesCache=_.$slides;_.unload();_.$slideTrack.children(this.options.slide).detach();_.$slidesCache.filter(filter).appendTo(_.$slideTrack);_.reinit()}};Slick.prototype.focusHandler=function(){var _=this;_.$slider.off("focus.slick blur.slick").on("focus.slick","*",function(event){var $sf=$(this);setTimeout(function(){if(_.options.pauseOnFocus){if($sf.is(":focus")){_.focussed=true;_.autoPlay()}}},0)}).on("blur.slick","*",function(event){var $sf=$(this);if(_.options.pauseOnFocus){_.focussed=false;_.autoPlay()}})};Slick.prototype.getCurrent=Slick.prototype.slickCurrentSlide=function(){var _=this;return _.currentSlide};Slick.prototype.getDotCount=function(){var _=this;var breakPoint=0;var counter=0;var pagerQty=0;if(_.options.infinite===true){if(_.slideCount<=_.options.slidesToShow){++pagerQty}else{while(breakPoint<_.slideCount){++pagerQty;breakPoint=counter+_.options.slidesToScroll;counter+=_.options.slidesToScroll<=_.options.slidesToShow?_.options.slidesToScroll:_.options.slidesToShow}}}else if(_.options.centerMode===true){pagerQty=_.slideCount}else if(!_.options.asNavFor){pagerQty=1+Math.ceil((_.slideCount-_.options.slidesToShow)/_.options.slidesToScroll)}else{while(breakPoint<_.slideCount){++pagerQty;breakPoint=counter+_.options.slidesToScroll;counter+=_.options.slidesToScroll<=_.options.slidesToShow?_.options.slidesToScroll:_.options.slidesToShow}}return pagerQty-1};Slick.prototype.getLeft=function(slideIndex){var _=this,targetLeft,verticalHeight,verticalOffset=0,targetSlide,coef;_.slideOffset=0;verticalHeight=_.$slides.first().outerHeight(true);if(_.options.infinite===true){if(_.slideCount>_.options.slidesToShow){_.slideOffset=_.slideWidth*_.options.slidesToShow*-1;coef=-1;if(_.options.vertical===true&&_.options.centerMode===true){if(_.options.slidesToShow===2){coef=-1.5}else if(_.options.slidesToShow===1){coef=-2}}verticalOffset=verticalHeight*_.options.slidesToShow*coef}if(_.slideCount%_.options.slidesToScroll!==0){if(slideIndex+_.options.slidesToScroll>_.slideCount&&_.slideCount>_.options.slidesToShow){if(slideIndex>_.slideCount){_.slideOffset=(_.options.slidesToShow-(slideIndex-_.slideCount))*_.slideWidth*-1;verticalOffset=(_.options.slidesToShow-(slideIndex-_.slideCount))*verticalHeight*-1}else{_.slideOffset=_.slideCount%_.options.slidesToScroll*_.slideWidth*-1;verticalOffset=_.slideCount%_.options.slidesToScroll*verticalHeight*-1}}}}else{if(slideIndex+_.options.slidesToShow>_.slideCount){_.slideOffset=(slideIndex+_.options.slidesToShow-_.slideCount)*_.slideWidth;verticalOffset=(slideIndex+_.options.slidesToShow-_.slideCount)*verticalHeight}}if(_.slideCount<=_.options.slidesToShow){_.slideOffset=0;verticalOffset=0}if(_.options.centerMode===true&&_.slideCount<=_.options.slidesToShow){_.slideOffset=_.slideWidth*Math.floor(_.options.slidesToShow)/2-_.slideWidth*_.slideCount/2}else if(_.options.centerMode===true&&_.options.infinite===true){_.slideOffset+=_.slideWidth*Math.floor(_.options.slidesToShow/2)-_.slideWidth}else if(_.options.centerMode===true){_.slideOffset=0;_.slideOffset+=_.slideWidth*Math.floor(_.options.slidesToShow/2)}if(_.options.vertical===false){targetLeft=slideIndex*_.slideWidth*-1+_.slideOffset}else{targetLeft=slideIndex*verticalHeight*-1+verticalOffset}if(_.options.variableWidth===true){if(_.slideCount<=_.options.slidesToShow||_.options.infinite===false){targetSlide=_.$slideTrack.children(".slick-slide").eq(slideIndex)}else{targetSlide=_.$slideTrack.children(".slick-slide").eq(slideIndex+_.options.slidesToShow)}if(_.options.rtl===true){if(targetSlide[0]){targetLeft=(_.$slideTrack.width()-targetSlide[0].offsetLeft-targetSlide.width())*-1}else{targetLeft=0}}else{targetLeft=targetSlide[0]?targetSlide[0].offsetLeft*-1:0}if(_.options.centerMode===true){if(_.slideCount<=_.options.slidesToShow||_.options.infinite===false){targetSlide=_.$slideTrack.children(".slick-slide").eq(slideIndex)}else{targetSlide=_.$slideTrack.children(".slick-slide").eq(slideIndex+_.options.slidesToShow+1)}if(_.options.rtl===true){if(targetSlide[0]){targetLeft=(_.$slideTrack.width()-targetSlide[0].offsetLeft-targetSlide.width())*-1}else{targetLeft=0}}else{targetLeft=targetSlide[0]?targetSlide[0].offsetLeft*-1:0}targetLeft+=(_.$list.width()-targetSlide.outerWidth())/2}}return targetLeft};Slick.prototype.getOption=Slick.prototype.slickGetOption=function(option){var _=this;return _.options[option]};Slick.prototype.getNavigableIndexes=function(){var _=this,breakPoint=0,counter=0,indexes=[],max;if(_.options.infinite===false){max=_.slideCount}else{breakPoint=_.options.slidesToScroll*-1;counter=_.options.slidesToScroll*-1;max=_.slideCount*2}while(breakPoint<max){indexes.push(breakPoint);breakPoint=counter+_.options.slidesToScroll;counter+=_.options.slidesToScroll<=_.options.slidesToShow?_.options.slidesToScroll:_.options.slidesToShow}return indexes};Slick.prototype.getSlick=function(){return this};Slick.prototype.getSlideCount=function(){var _=this,slidesTraversed,swipedSlide,swipeTarget,centerOffset;centerOffset=_.options.centerMode===true?Math.floor(_.$list.width()/2):0;swipeTarget=_.swipeLeft*-1+centerOffset;if(_.options.swipeToSlide===true){_.$slideTrack.find(".slick-slide").each(function(index,slide){var slideOuterWidth,slideOffset,slideRightBoundary;slideOuterWidth=$(slide).outerWidth();slideOffset=slide.offsetLeft;if(_.options.centerMode!==true){slideOffset+=slideOuterWidth/2}slideRightBoundary=slideOffset+slideOuterWidth;if(swipeTarget<slideRightBoundary){swipedSlide=slide;return false}});slidesTraversed=Math.abs($(swipedSlide).attr("data-slick-index")-_.currentSlide)||1;return slidesTraversed}else{return _.options.slidesToScroll}};Slick.prototype.goTo=Slick.prototype.slickGoTo=function(slide,dontAnimate){var _=this;_.changeSlide({data:{message:"index",index:parseInt(slide)}},dontAnimate)};Slick.prototype.init=function(creation){var _=this;if(!$(_.$slider).hasClass("slick-initialized")){$(_.$slider).addClass("slick-initialized");_.buildRows();_.buildOut();_.setProps();_.startLoad();_.loadSlider();_.initializeEvents();_.updateArrows();_.updateDots();_.checkResponsive(true);_.focusHandler()}if(creation){_.$slider.trigger("init",[_])}if(_.options.accessibility===true){_.initADA()}if(_.options.autoplay){_.paused=false;_.autoPlay()}};Slick.prototype.initADA=function(){var _=this,numDotGroups=Math.ceil(_.slideCount/_.options.slidesToShow),tabControlIndexes=_.getNavigableIndexes().filter(function(val){return val>=0&&val<_.slideCount});_.$slides.add(_.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"});if(_.$dots!==null){_.$slides.not(_.$slideTrack.find(".slick-cloned")).each(function(i){var slideControlIndex=tabControlIndexes.indexOf(i);$(this).attr({role:"tabpanel",id:"slick-slide"+_.instanceUid+i,tabindex:-1});if(slideControlIndex!==-1){var ariaButtonControl="slick-slide-control"+_.instanceUid+slideControlIndex;if($("#"+ariaButtonControl).length){$(this).attr({"aria-describedby":ariaButtonControl})}}});_.$dots.attr("role","tablist").find("li").each(function(i){var mappedSlideIndex=tabControlIndexes[i];$(this).attr({role:"presentation"});$(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+_.instanceUid+i,"aria-controls":"slick-slide"+_.instanceUid+mappedSlideIndex,"aria-label":i+1+" of "+numDotGroups,"aria-selected":null,tabindex:"-1"})}).eq(_.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end()}for(var i=_.currentSlide,max=i+_.options.slidesToShow;i<max;i++){if(_.options.focusOnChange){_.$slides.eq(i).attr({tabindex:"0"})}else{_.$slides.eq(i).removeAttr("tabindex")}}_.activateADA()};Slick.prototype.initArrowEvents=function(){var _=this;if(_.options.arrows===true&&_.slideCount>_.options.slidesToShow){_.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},_.changeSlide);_.$nextArrow.off("click.slick").on("click.slick",{message:"next"},_.changeSlide);if(_.options.accessibility===true){_.$prevArrow.on("keydown.slick",_.keyHandler);_.$nextArrow.on("keydown.slick",_.keyHandler)}}};Slick.prototype.initDotEvents=function(){var _=this;if(_.options.dots===true&&_.slideCount>_.options.slidesToShow){$("li",_.$dots).on("click.slick",{message:"index"},_.changeSlide);if(_.options.accessibility===true){_.$dots.on("keydown.slick",_.keyHandler)}}if(_.options.dots===true&&_.options.pauseOnDotsHover===true&&_.slideCount>_.options.slidesToShow){$("li",_.$dots).on("mouseenter.slick",$.proxy(_.interrupt,_,true)).on("mouseleave.slick",$.proxy(_.interrupt,_,false))}};Slick.prototype.initSlideEvents=function(){var _=this;if(_.options.pauseOnHover){_.$list.on("mouseenter.slick",$.proxy(_.interrupt,_,true));_.$list.on("mouseleave.slick",$.proxy(_.interrupt,_,false))}};Slick.prototype.initializeEvents=function(){var _=this;_.initArrowEvents();_.initDotEvents();_.initSlideEvents();_.$list.on("touchstart.slick mousedown.slick",{action:"start"},_.swipeHandler);_.$list.on("touchmove.slick mousemove.slick",{action:"move"},_.swipeHandler);_.$list.on("touchend.slick mouseup.slick",{action:"end"},_.swipeHandler);_.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},_.swipeHandler);_.$list.on("click.slick",_.clickHandler);$(document).on(_.visibilityChange,$.proxy(_.visibility,_));if(_.options.accessibility===true){_.$list.on("keydown.slick",_.keyHandler)}if(_.options.focusOnSelect===true){$(_.$slideTrack).children().on("click.slick",_.selectHandler)}$(window).on("orientationchange.slick.slick-"+_.instanceUid,$.proxy(_.orientationChange,_));$(window).on("resize.slick.slick-"+_.instanceUid,$.proxy(_.resize,_));$("[draggable!=true]",_.$slideTrack).on("dragstart",_.preventDefault);$(window).on("load.slick.slick-"+_.instanceUid,_.setPosition);$(_.setPosition)};Slick.prototype.initUI=function(){var _=this;if(_.options.arrows===true&&_.slideCount>_.options.slidesToShow){_.$prevArrow.show();_.$nextArrow.show()}if(_.options.dots===true&&_.slideCount>_.options.slidesToShow){_.$dots.show()}};Slick.prototype.keyHandler=function(event){var _=this;if(!event.target.tagName.match("TEXTAREA|INPUT|SELECT")){if(event.keyCode===37&&_.options.accessibility===true){_.changeSlide({data:{message:_.options.rtl===true?"next":"previous"}})}else if(event.keyCode===39&&_.options.accessibility===true){_.changeSlide({data:{message:_.options.rtl===true?"previous":"next"}})}}};Slick.prototype.lazyLoad=function(){var _=this,loadRange,cloneRange,rangeStart,rangeEnd;function loadImages(imagesScope){$("img[data-lazy]",imagesScope).each(function(){var image=$(this),imageSource=$(this).attr("data-lazy"),imageSrcSet=$(this).attr("data-srcset"),imageSizes=$(this).attr("data-sizes")||_.$slider.attr("data-sizes"),imageToLoad=document.createElement("img");imageToLoad.onload=function(){image.animate({opacity:0},100,function(){if(imageSrcSet){image.attr("srcset",imageSrcSet);if(imageSizes){image.attr("sizes",imageSizes)}}image.attr("src",imageSource).animate({opacity:1},200,function(){image.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")});_.$slider.trigger("lazyLoaded",[_,image,imageSource])})};imageToLoad.onerror=function(){image.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error");_.$slider.trigger("lazyLoadError",[_,image,imageSource])};imageToLoad.src=imageSource})}if(_.options.centerMode===true){if(_.options.infinite===true){rangeStart=_.currentSlide+(_.options.slidesToShow/2+1);rangeEnd=rangeStart+_.options.slidesToShow+2}else{rangeStart=Math.max(0,_.currentSlide-(_.options.slidesToShow/2+1));rangeEnd=2+(_.options.slidesToShow/2+1)+_.currentSlide}}else{rangeStart=_.options.infinite?_.options.slidesToShow+_.currentSlide:_.currentSlide;rangeEnd=Math.ceil(rangeStart+_.options.slidesToShow);if(_.options.fade===true){if(rangeStart>0)rangeStart--;if(rangeEnd<=_.slideCount)rangeEnd++}}loadRange=_.$slider.find(".slick-slide").slice(rangeStart,rangeEnd);if(_.options.lazyLoad==="anticipated"){var prevSlide=rangeStart-1,nextSlide=rangeEnd,$slides=_.$slider.find(".slick-slide");for(var i=0;i<_.options.slidesToScroll;i++){if(prevSlide<0)prevSlide=_.slideCount-1;loadRange=loadRange.add($slides.eq(prevSlide));loadRange=loadRange.add($slides.eq(nextSlide));prevSlide--;nextSlide++}}loadImages(loadRange);if(_.slideCount<=_.options.slidesToShow){cloneRange=_.$slider.find(".slick-slide");loadImages(cloneRange)}else if(_.currentSlide>=_.slideCount-_.options.slidesToShow){cloneRange=_.$slider.find(".slick-cloned").slice(0,_.options.slidesToShow);loadImages(cloneRange)}else if(_.currentSlide===0){cloneRange=_.$slider.find(".slick-cloned").slice(_.options.slidesToShow*-1);loadImages(cloneRange)}};Slick.prototype.loadSlider=function(){var _=this;_.setPosition();_.$slideTrack.css({opacity:1});_.$slider.removeClass("slick-loading");_.initUI();if(_.options.lazyLoad==="progressive"){_.progressiveLazyLoad()}};Slick.prototype.next=Slick.prototype.slickNext=function(){var _=this;_.changeSlide({data:{message:"next"}})};Slick.prototype.orientationChange=function(){var _=this;_.checkResponsive();_.setPosition()};Slick.prototype.pause=Slick.prototype.slickPause=function(){var _=this;_.autoPlayClear();_.paused=true};Slick.prototype.play=Slick.prototype.slickPlay=function(){var _=this;_.autoPlay();_.options.autoplay=true;_.paused=false;_.focussed=false;_.interrupted=false};Slick.prototype.postSlide=function(index){var _=this;if(!_.unslicked){_.$slider.trigger("afterChange",[_,index]);_.animating=false;if(_.slideCount>_.options.slidesToShow){_.setPosition()}_.swipeLeft=null;if(_.options.autoplay){_.autoPlay()}if(_.options.accessibility===true){_.initADA();if(_.options.focusOnChange){var $currentSlide=$(_.$slides.get(_.currentSlide));$currentSlide.attr("tabindex",0).focus()}}}};Slick.prototype.prev=Slick.prototype.slickPrev=function(){var _=this;_.changeSlide({data:{message:"previous"}})};Slick.prototype.preventDefault=function(event){event.preventDefault()};Slick.prototype.progressiveLazyLoad=function(tryCount){tryCount=tryCount||1;var _=this,$imgsToLoad=$("img[data-lazy]",_.$slider),image,imageSource,imageSrcSet,imageSizes,imageToLoad;if($imgsToLoad.length){image=$imgsToLoad.first();imageSource=image.attr("data-lazy");imageSrcSet=image.attr("data-srcset");imageSizes=image.attr("data-sizes")||_.$slider.attr("data-sizes");imageToLoad=document.createElement("img");imageToLoad.onload=function(){if(imageSrcSet){image.attr("srcset",imageSrcSet);if(imageSizes){image.attr("sizes",imageSizes)}}image.attr("src",imageSource).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading");if(_.options.adaptiveHeight===true){_.setPosition()}_.$slider.trigger("lazyLoaded",[_,image,imageSource]);_.progressiveLazyLoad()};imageToLoad.onerror=function(){if(tryCount<3){setTimeout(function(){_.progressiveLazyLoad(tryCount+1)},500)}else{image.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error");_.$slider.trigger("lazyLoadError",[_,image,imageSource]);_.progressiveLazyLoad()}};imageToLoad.src=imageSource}else{_.$slider.trigger("allImagesLoaded",[_])}};Slick.prototype.refresh=function(initializing){var _=this,currentSlide,lastVisibleIndex;lastVisibleIndex=_.slideCount-_.options.slidesToShow;if(!_.options.infinite&&_.currentSlide>lastVisibleIndex){_.currentSlide=lastVisibleIndex}if(_.slideCount<=_.options.slidesToShow){_.currentSlide=0}currentSlide=_.currentSlide;_.destroy(true);$.extend(_,_.initials,{currentSlide:currentSlide});_.init();if(!initializing){_.changeSlide({data:{message:"index",index:currentSlide}},false)}};Slick.prototype.registerBreakpoints=function(){var _=this,breakpoint,currentBreakpoint,l,responsiveSettings=_.options.responsive||null;if($.type(responsiveSettings)==="array"&&responsiveSettings.length){_.respondTo=_.options.respondTo||"window";for(breakpoint in responsiveSettings){l=_.breakpoints.length-1;if(responsiveSettings.hasOwnProperty(breakpoint)){currentBreakpoint=responsiveSettings[breakpoint].breakpoint;while(l>=0){if(_.breakpoints[l]&&_.breakpoints[l]===currentBreakpoint){_.breakpoints.splice(l,1)}l--}_.breakpoints.push(currentBreakpoint);_.breakpointSettings[currentBreakpoint]=responsiveSettings[breakpoint].settings}}_.breakpoints.sort(function(a,b){return _.options.mobileFirst?a-b:b-a})}};Slick.prototype.reinit=function(){var _=this;_.$slides=_.$slideTrack.children(_.options.slide).addClass("slick-slide");_.slideCount=_.$slides.length;if(_.currentSlide>=_.slideCount&&_.currentSlide!==0){_.currentSlide=_.currentSlide-_.options.slidesToScroll}if(_.slideCount<=_.options.slidesToShow){_.currentSlide=0}_.registerBreakpoints();_.setProps();_.setupInfinite();_.buildArrows();_.updateArrows();_.initArrowEvents();_.buildDots();_.updateDots();_.initDotEvents();_.cleanUpSlideEvents();_.initSlideEvents();_.checkResponsive(false,true);if(_.options.focusOnSelect===true){$(_.$slideTrack).children().on("click.slick",_.selectHandler)}_.setSlideClasses(typeof _.currentSlide==="number"?_.currentSlide:0);_.setPosition();_.focusHandler();_.paused=!_.options.autoplay;_.autoPlay();_.$slider.trigger("reInit",[_])};Slick.prototype.resize=function(){var _=this;if($(window).width()!==_.windowWidth){clearTimeout(_.windowDelay);_.windowDelay=window.setTimeout(function(){_.windowWidth=$(window).width();_.checkResponsive();if(!_.unslicked){_.setPosition()}},50)}};Slick.prototype.removeSlide=Slick.prototype.slickRemove=function(index,removeBefore,removeAll){var _=this;if(typeof index==="boolean"){removeBefore=index;index=removeBefore===true?0:_.slideCount-1}else{index=removeBefore===true?--index:index}if(_.slideCount<1||index<0||index>_.slideCount-1){return false}_.unload();if(removeAll===true){_.$slideTrack.children().remove()}else{_.$slideTrack.children(this.options.slide).eq(index).remove()}_.$slides=_.$slideTrack.children(this.options.slide);_.$slideTrack.children(this.options.slide).detach();_.$slideTrack.append(_.$slides);_.$slidesCache=_.$slides;_.reinit()};Slick.prototype.setCSS=function(position){var _=this,positionProps={},x,y;if(_.options.rtl===true){position=-position}x=_.positionProp=="left"?Math.ceil(position)+"px":"0px";y=_.positionProp=="top"?Math.ceil(position)+"px":"0px";positionProps[_.positionProp]=position;if(_.transformsEnabled===false){_.$slideTrack.css(positionProps)}else{positionProps={};if(_.cssTransitions===false){positionProps[_.animType]="translate("+x+", "+y+")";_.$slideTrack.css(positionProps)}else{positionProps[_.animType]="translate3d("+x+", "+y+", 0px)";_.$slideTrack.css(positionProps)}}};Slick.prototype.setDimensions=function(){var _=this;if(_.options.vertical===false){if(_.options.centerMode===true){_.$list.css({padding:"0px "+_.options.centerPadding})}}else{_.$list.height(_.$slides.first().outerHeight(true)*_.options.slidesToShow);if(_.options.centerMode===true){_.$list.css({padding:_.options.centerPadding+" 0px"})}}_.listWidth=_.$list.width();_.listHeight=_.$list.height();if(_.options.vertical===false&&_.options.variableWidth===false){_.slideWidth=Math.ceil(_.listWidth/_.options.slidesToShow);_.$slideTrack.width(Math.ceil(_.slideWidth*_.$slideTrack.children(".slick-slide").length))}else if(_.options.variableWidth===true){_.$slideTrack.width(5e3*_.slideCount)}else{_.slideWidth=Math.ceil(_.listWidth);_.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true)*_.$slideTrack.children(".slick-slide").length))}var offset=_.$slides.first().outerWidth(true)-_.$slides.first().width();if(_.options.variableWidth===false)_.$slideTrack.children(".slick-slide").width(_.slideWidth-offset)};Slick.prototype.setFade=function(){var _=this,targetLeft;_.$slides.each(function(index,element){targetLeft=_.slideWidth*index*-1;if(_.options.rtl===true){$(element).css({position:"relative",right:targetLeft,top:0,zIndex:_.options.zIndex-2,opacity:0})}else{$(element).css({position:"relative",left:targetLeft,top:0,zIndex:_.options.zIndex-2,opacity:0})}});_.$slides.eq(_.currentSlide).css({zIndex:_.options.zIndex-1,opacity:1})};Slick.prototype.setHeight=function(){var _=this;if(_.options.slidesToShow===1&&_.options.adaptiveHeight===true&&_.options.vertical===false){var targetHeight=_.$slides.eq(_.currentSlide).outerHeight(true);_.$list.css("height",targetHeight)}};Slick.prototype.setOption=Slick.prototype.slickSetOption=function(){var _=this,l,item,option,value,refresh=false,type;if($.type(arguments[0])==="object"){option=arguments[0];refresh=arguments[1];type="multiple"}else if($.type(arguments[0])==="string"){option=arguments[0];value=arguments[1];refresh=arguments[2];if(arguments[0]==="responsive"&&$.type(arguments[1])==="array"){type="responsive"}else if(typeof arguments[1]!=="undefined"){type="single"}}if(type==="single"){_.options[option]=value}else if(type==="multiple"){$.each(option,function(opt,val){_.options[opt]=val})}else if(type==="responsive"){for(item in value){if($.type(_.options.responsive)!=="array"){_.options.responsive=[value[item]]}else{l=_.options.responsive.length-1;while(l>=0){if(_.options.responsive[l].breakpoint===value[item].breakpoint){_.options.responsive.splice(l,1)}l--}_.options.responsive.push(value[item])}}}if(refresh){_.unload();_.reinit()}};Slick.prototype.setPosition=function(){var _=this;_.setDimensions();_.setHeight();if(_.options.fade===false){_.setCSS(_.getLeft(_.currentSlide))}else{_.setFade()}_.$slider.trigger("setPosition",[_])};Slick.prototype.setProps=function(){var _=this,bodyStyle=document.body.style;_.positionProp=_.options.vertical===true?"top":"left";if(_.positionProp==="top"){_.$slider.addClass("slick-vertical")}else{_.$slider.removeClass("slick-vertical")}if(bodyStyle.WebkitTransition!==undefined||bodyStyle.MozTransition!==undefined||bodyStyle.msTransition!==undefined){if(_.options.useCSS===true){_.cssTransitions=true}}if(_.options.fade){if(typeof _.options.zIndex==="number"){if(_.options.zIndex<3){_.options.zIndex=3}}else{_.options.zIndex=_.defaults.zIndex}}if(bodyStyle.OTransform!==undefined){_.animType="OTransform";_.transformType="-o-transform";_.transitionType="OTransition";if(bodyStyle.perspectiveProperty===undefined&&bodyStyle.webkitPerspective===undefined)_.animType=false}if(bodyStyle.MozTransform!==undefined){_.animType="MozTransform";_.transformType="-moz-transform";_.transitionType="MozTransition";if(bodyStyle.perspectiveProperty===undefined&&bodyStyle.MozPerspective===undefined)_.animType=false}if(bodyStyle.webkitTransform!==undefined){_.animType="webkitTransform";_.transformType="-webkit-transform";_.transitionType="webkitTransition";if(bodyStyle.perspectiveProperty===undefined&&bodyStyle.webkitPerspective===undefined)_.animType=false}if(bodyStyle.msTransform!==undefined){_.animType="msTransform";_.transformType="-ms-transform";_.transitionType="msTransition";if(bodyStyle.msTransform===undefined)_.animType=false}if(bodyStyle.transform!==undefined&&_.animType!==false){_.animType="transform";_.transformType="transform";_.transitionType="transition"}_.transformsEnabled=_.options.useTransform&&(_.animType!==null&&_.animType!==false)};Slick.prototype.setSlideClasses=function(index){var _=this,centerOffset,allSlides,indexOffset,remainder;allSlides=_.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true");_.$slides.eq(index).addClass("slick-current");if(_.options.centerMode===true){var evenCoef=_.options.slidesToShow%2===0?1:0;centerOffset=Math.floor(_.options.slidesToShow/2);if(_.options.infinite===true){if(index>=centerOffset&&index<=_.slideCount-1-centerOffset){_.$slides.slice(index-centerOffset+evenCoef,index+centerOffset+1).addClass("slick-active").attr("aria-hidden","false")}else{indexOffset=_.options.slidesToShow+index;allSlides.slice(indexOffset-centerOffset+1+evenCoef,indexOffset+centerOffset+2).addClass("slick-active").attr("aria-hidden","false")}if(index===0){allSlides.eq(allSlides.length-1-_.options.slidesToShow).addClass("slick-center")}else if(index===_.slideCount-1){allSlides.eq(_.options.slidesToShow).addClass("slick-center")}}_.$slides.eq(index).addClass("slick-center")}else{if(index>=0&&index<=_.slideCount-_.options.slidesToShow){_.$slides.slice(index,index+_.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false")}else if(allSlides.length<=_.options.slidesToShow){allSlides.addClass("slick-active").attr("aria-hidden","false")}else{remainder=_.slideCount%_.options.slidesToShow;indexOffset=_.options.infinite===true?_.options.slidesToShow+index:index;if(_.options.slidesToShow==_.options.slidesToScroll&&_.slideCount-index<_.options.slidesToShow){allSlides.slice(indexOffset-(_.options.slidesToShow-remainder),indexOffset+remainder).addClass("slick-active").attr("aria-hidden","false")}else{allSlides.slice(indexOffset,indexOffset+_.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false")}}}if(_.options.lazyLoad==="ondemand"||_.options.lazyLoad==="anticipated"){_.lazyLoad()}};Slick.prototype.setupInfinite=function(){var _=this,i,slideIndex,infiniteCount;if(_.options.fade===true){_.options.centerMode=false}if(_.options.infinite===true&&_.options.fade===false){slideIndex=null;if(_.slideCount>_.options.slidesToShow){if(_.options.centerMode===true){infiniteCount=_.options.slidesToShow+1}else{infiniteCount=_.options.slidesToShow}for(i=_.slideCount;i>_.slideCount-infiniteCount;i-=1){slideIndex=i-1;$(_.$slides[slideIndex]).clone(true).attr("id","").attr("data-slick-index",slideIndex-_.slideCount).prependTo(_.$slideTrack).addClass("slick-cloned")}for(i=0;i<infiniteCount+_.slideCount;i+=1){slideIndex=i;$(_.$slides[slideIndex]).clone(true).attr("id","").attr("data-slick-index",slideIndex+_.slideCount).appendTo(_.$slideTrack).addClass("slick-cloned")}_.$slideTrack.find(".slick-cloned").find("[id]").each(function(){$(this).attr("id","")})}}};Slick.prototype.interrupt=function(toggle){var _=this;if(!toggle){_.autoPlay()}_.interrupted=toggle};Slick.prototype.selectHandler=function(event){var _=this;var targetElement=$(event.target).is(".slick-slide")?$(event.target):$(event.target).parents(".slick-slide");var index=parseInt(targetElement.attr("data-slick-index"));if(!index)index=0;if(_.slideCount<=_.options.slidesToShow){_.slideHandler(index,false,true);return}_.slideHandler(index)};Slick.prototype.slideHandler=function(index,sync,dontAnimate){var targetSlide,animSlide,oldSlide,slideLeft,targetLeft=null,_=this,navTarget;sync=sync||false;if(_.animating===true&&_.options.waitForAnimate===true){return}if(_.options.fade===true&&_.currentSlide===index){return}if(sync===false){_.asNavFor(index)}targetSlide=index;targetLeft=_.getLeft(targetSlide);slideLeft=_.getLeft(_.currentSlide);_.currentLeft=_.swipeLeft===null?slideLeft:_.swipeLeft;if(_.options.infinite===false&&_.options.centerMode===false&&(index<0||index>_.getDotCount()*_.options.slidesToScroll)){if(_.options.fade===false){targetSlide=_.currentSlide;if(dontAnimate!==true&&_.slideCount>_.options.slidesToShow){_.animateSlide(slideLeft,function(){_.postSlide(targetSlide)})}else{_.postSlide(targetSlide)}}return}else if(_.options.infinite===false&&_.options.centerMode===true&&(index<0||index>_.slideCount-_.options.slidesToScroll)){if(_.options.fade===false){targetSlide=_.currentSlide;if(dontAnimate!==true&&_.slideCount>_.options.slidesToShow){_.animateSlide(slideLeft,function(){_.postSlide(targetSlide)})}else{_.postSlide(targetSlide)}}return}if(_.options.autoplay){clearInterval(_.autoPlayTimer)}if(targetSlide<0){if(_.slideCount%_.options.slidesToScroll!==0){animSlide=_.slideCount-_.slideCount%_.options.slidesToScroll}else{animSlide=_.slideCount+targetSlide}}else if(targetSlide>=_.slideCount){if(_.slideCount%_.options.slidesToScroll!==0){animSlide=0}else{animSlide=targetSlide-_.slideCount}}else{animSlide=targetSlide}_.animating=true;_.$slider.trigger("beforeChange",[_,_.currentSlide,animSlide]);oldSlide=_.currentSlide;_.currentSlide=animSlide;_.setSlideClasses(_.currentSlide);if(_.options.asNavFor){navTarget=_.getNavTarget();navTarget=navTarget.slick("getSlick");if(navTarget.slideCount<=navTarget.options.slidesToShow){navTarget.setSlideClasses(_.currentSlide)}}_.updateDots();_.updateArrows();if(_.options.fade===true){if(dontAnimate!==true){_.fadeSlideOut(oldSlide);_.fadeSlide(animSlide,function(){_.postSlide(animSlide)})}else{_.postSlide(animSlide)}_.animateHeight();return}if(dontAnimate!==true&&_.slideCount>_.options.slidesToShow){_.animateSlide(targetLeft,function(){_.postSlide(animSlide)})}else{_.postSlide(animSlide)}};Slick.prototype.startLoad=function(){var _=this;if(_.options.arrows===true&&_.slideCount>_.options.slidesToShow){_.$prevArrow.hide();_.$nextArrow.hide()}if(_.options.dots===true&&_.slideCount>_.options.slidesToShow){_.$dots.hide()}_.$slider.addClass("slick-loading")};Slick.prototype.swipeDirection=function(){var xDist,yDist,r,swipeAngle,_=this;xDist=_.touchObject.startX-_.touchObject.curX;yDist=_.touchObject.startY-_.touchObject.curY;r=Math.atan2(yDist,xDist);swipeAngle=Math.round(r*180/Math.PI);if(swipeAngle<0){swipeAngle=360-Math.abs(swipeAngle)}if(swipeAngle<=45&&swipeAngle>=0){return _.options.rtl===false?"left":"right"}if(swipeAngle<=360&&swipeAngle>=315){return _.options.rtl===false?"left":"right"}if(swipeAngle>=135&&swipeAngle<=225){return _.options.rtl===false?"right":"left"}if(_.options.verticalSwiping===true){if(swipeAngle>=35&&swipeAngle<=135){return"down"}else{return"up"}}return"vertical"};Slick.prototype.swipeEnd=function(event){var _=this,slideCount,direction;_.dragging=false;_.swiping=false;if(_.scrolling){_.scrolling=false;return false}_.interrupted=false;_.shouldClick=_.touchObject.swipeLength>10?false:true;if(_.touchObject.curX===undefined){return false}if(_.touchObject.edgeHit===true){_.$slider.trigger("edge",[_,_.swipeDirection()])}if(_.touchObject.swipeLength>=_.touchObject.minSwipe){direction=_.swipeDirection();switch(direction){case"left":case"down":slideCount=_.options.swipeToSlide?_.checkNavigable(_.currentSlide+_.getSlideCount()):_.currentSlide+_.getSlideCount();_.currentDirection=0;break;case"right":case"up":slideCount=_.options.swipeToSlide?_.checkNavigable(_.currentSlide-_.getSlideCount()):_.currentSlide-_.getSlideCount();_.currentDirection=1;break;default:}if(direction!="vertical"){_.slideHandler(slideCount);_.touchObject={};_.$slider.trigger("swipe",[_,direction])}}else{if(_.touchObject.startX!==_.touchObject.curX){_.slideHandler(_.currentSlide);_.touchObject={}}}};Slick.prototype.swipeHandler=function(event){var _=this;if(_.options.swipe===false||"ontouchend"in document&&_.options.swipe===false){return}else if(_.options.draggable===false&&event.type.indexOf("mouse")!==-1){return}_.touchObject.fingerCount=event.originalEvent&&event.originalEvent.touches!==undefined?event.originalEvent.touches.length:1;_.touchObject.minSwipe=_.listWidth/_.options.touchThreshold;if(_.options.verticalSwiping===true){_.touchObject.minSwipe=_.listHeight/_.options.touchThreshold}switch(event.data.action){case"start":_.swipeStart(event);break;case"move":_.swipeMove(event);break;case"end":_.swipeEnd(event);break}};Slick.prototype.swipeMove=function(event){var _=this,edgeWasHit=false,curLeft,swipeDirection,swipeLength,positionOffset,touches,verticalSwipeLength;touches=event.originalEvent!==undefined?event.originalEvent.touches:null;if(!_.dragging||_.scrolling||touches&&touches.length!==1){return false}curLeft=_.getLeft(_.currentSlide);_.touchObject.curX=touches!==undefined?touches[0].pageX:event.clientX;_.touchObject.curY=touches!==undefined?touches[0].pageY:event.clientY;_.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(_.touchObject.curX-_.touchObject.startX,2)));verticalSwipeLength=Math.round(Math.sqrt(Math.pow(_.touchObject.curY-_.touchObject.startY,2)));if(!_.options.verticalSwiping&&!_.swiping&&verticalSwipeLength>4){_.scrolling=true;return false}if(_.options.verticalSwiping===true){_.touchObject.swipeLength=verticalSwipeLength}swipeDirection=_.swipeDirection();if(event.originalEvent!==undefined&&_.touchObject.swipeLength>4){_.swiping=true;event.preventDefault()}positionOffset=(_.options.rtl===false?1:-1)*(_.touchObject.curX>_.touchObject.startX?1:-1);if(_.options.verticalSwiping===true){positionOffset=_.touchObject.curY>_.touchObject.startY?1:-1}swipeLength=_.touchObject.swipeLength;_.touchObject.edgeHit=false;if(_.options.infinite===false){if(_.currentSlide===0&&swipeDirection==="right"||_.currentSlide>=_.getDotCount()&&swipeDirection==="left"){swipeLength=_.touchObject.swipeLength*_.options.edgeFriction;_.touchObject.edgeHit=true}}if(_.options.vertical===false){_.swipeLeft=curLeft+swipeLength*positionOffset}else{_.swipeLeft=curLeft+swipeLength*(_.$list.height()/_.listWidth)*positionOffset}if(_.options.verticalSwiping===true){_.swipeLeft=curLeft+swipeLength*positionOffset}if(_.options.fade===true||_.options.touchMove===false){return false}if(_.animating===true){_.swipeLeft=null;return false}_.setCSS(_.swipeLeft)};Slick.prototype.swipeStart=function(event){var _=this,touches;_.interrupted=true;if(_.touchObject.fingerCount!==1||_.slideCount<=_.options.slidesToShow){_.touchObject={};return false}if(event.originalEvent!==undefined&&event.originalEvent.touches!==undefined){touches=event.originalEvent.touches[0]}_.touchObject.startX=_.touchObject.curX=touches!==undefined?touches.pageX:event.clientX;_.touchObject.startY=_.touchObject.curY=touches!==undefined?touches.pageY:event.clientY;_.dragging=true};Slick.prototype.unfilterSlides=Slick.prototype.slickUnfilter=function(){var _=this;if(_.$slidesCache!==null){_.unload();_.$slideTrack.children(this.options.slide).detach();_.$slidesCache.appendTo(_.$slideTrack);_.reinit()}};Slick.prototype.unload=function(){var _=this;$(".slick-cloned",_.$slider).remove();if(_.$dots){_.$dots.remove()}if(_.$prevArrow&&_.htmlExpr.test(_.options.prevArrow)){_.$prevArrow.remove()}if(_.$nextArrow&&_.htmlExpr.test(_.options.nextArrow)){_.$nextArrow.remove()}_.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")};Slick.prototype.unslick=function(fromBreakpoint){var _=this;_.$slider.trigger("unslick",[_,fromBreakpoint]);_.destroy()};Slick.prototype.updateArrows=function(){var _=this,centerOffset;centerOffset=Math.floor(_.options.slidesToShow/2);if(_.options.arrows===true&&_.slideCount>_.options.slidesToShow&&!_.options.infinite){_.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false");_.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false");if(_.currentSlide===0){_.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true");_.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")}else if(_.currentSlide>=_.slideCount-_.options.slidesToShow&&_.options.centerMode===false){_.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true");_.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")}else if(_.currentSlide>=_.slideCount-1&&_.options.centerMode===true){_.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true");_.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")}}};Slick.prototype.updateDots=function(){var _=this;if(_.$dots!==null){_.$dots.find("li").removeClass("slick-active").end();_.$dots.find("li").eq(Math.floor(_.currentSlide/_.options.slidesToScroll)).addClass("slick-active")}};Slick.prototype.visibility=function(){var _=this;if(_.options.autoplay){if(document[_.hidden]){_.interrupted=true}else{_.interrupted=false}}};$.fn.slick=function(){var _=this,opt=arguments[0],args=Array.prototype.slice.call(arguments,1),l=_.length,i,ret;for(i=0;i<l;i++){if(typeof opt=="object"||typeof opt=="undefined")_[i].slick=new Slick(_[i],opt);else ret=_[i].slick[opt].apply(_[i].slick,args);if(typeof ret!="undefined")return ret}return _}});

